import { render, staticRenderFns } from "./MenteeMentorships.vue?vue&type=template&id=0b9ddbda&"
import script from "./MenteeMentorships.vue?vue&type=script&lang=js&"
export * from "./MenteeMentorships.vue?vue&type=script&lang=js&"
import style0 from "./MenteeMentorships.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports